import React from "react";
import * as app from "../services/AppService";
import { RowItem } from "../models/Core/row-item";

interface StatisticDivProps extends RowItem {
    label: string,
    extentionClass: string,
    containerClass: string
    labelClass: string,
    class: string,
    model: string | number,
    children: React.ReactElement[] | React.ReactElement
}
function StatisticDiv(props: Partial<StatisticDivProps>) {
    return (
        <div className={`rounded border border-1 height-31 d-flex align-items-center ${props.containerClass! + props.extentionClass!}`}>
            <div className={`text-start mx-2 my-1 fw-medium ${props.labelClass}`}>
                {app.translate(props.label)} :
                <div className={`d-inline-block mx-2 fw-bold ${props.class}`}>{props.model}</div>
            </div>
        </div>
    );
}

StatisticDiv.defaultProps = {
    class: "",
    labelClass: "text-light-subtle ",
    resultClass: "text-success-emphasis ",
    extentionClass:""
};

export default StatisticDiv;
